var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ot-section',_vm._b({attrs:{"theme":_vm.$otTheme,"section":""}},'ot-section',_vm.$attrs,false),[_c('ot-row-group',{attrs:{"theme":_vm.$otTheme,"code":_vm.code}},[_c('ot-time-picker',{attrs:{"theme":_vm.$otTheme,"round":"","options":{
            start: '08:30',
            step: '00:15',
            end: '18:30',
        }},model:{value:(_vm.timepicker),callback:function ($$v) {_vm.timepicker=$$v},expression:"timepicker"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }